import {
  Component,
  ViewEncapsulation,
  OnInit,
  ViewChild,
  QueryList,
  AfterViewInit,
  ViewChildren,
} from '@angular/core';
import { KYMW00Model } from '../../../commons/kymw00/kymw00.model';
import { KYMW0001Model } from './kymw0001.model';
import { PlessDialogServiceSub } from '../../../commons/kymw00/pless-dialog-service-sub';
import { PlessViewHelperSub } from '../../../commons/kymw00/pless-view-helper-sub';
import { FlexGrid, CellType } from '@grapecity/wijmo.grid';
import { WjFlexGrid } from '@grapecity/wijmo.angular2.grid';
import { GetMarkCodeListService } from './api-services/get-mark-code-list.service';
import { KYMW0001InputModel } from './vo/kymw0001-input.model';
import { KYMW0001OutputModel } from './vo/kymw0001-output.model';
import { MarkCodeInfo } from './vo/mark-code-info.model';
import { PlessViewUtilsSub } from '../pless-view-utils-sub.service';

/**
 * マーク選択を管理するクラス
 *
 * @export KYMW0001Component
 * @class KYMW0001Component
 */
@Component({
  selector: 'app-kymw0001',
  templateUrl: 'kymw0001.component.html',
  styleUrls: ['kymw0001.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class KYMW0001Component
  extends PlessViewHelperSub
  implements OnInit
{
  public model: KYMW0001Model = new KYMW0001Model();

  @ViewChild('dtg_MarkCodeList', { static: false }) dtg_MarkCodeList: FlexGrid;

  /**
   * Creates an instance of KYMW0001Component.
   *
   * @param {PlessDialogServiceSub} dialogService
   * @param {GetTagGroupListService} getTagGroupListService
   * @param {KYMW00Model} kymw00Model
   * @memberof KYMW0001Component
   */
  constructor(
    private kymw00Model: KYMW00Model,
    private getMarkCodeListService: GetMarkCodeListService,
  ) {
    super(kymw00Model);
  }

  /**
   * コンポーネント初期化
   *
   * @memberof KYMW0001Component
   */
  public ngOnInit(): void {
    this.componentName = 'KYMW0001';

    if(this.model.windowOpenFlg == 0) {
      this.model.windowTitle = "商品マーク";
    }else if(this.model.windowOpenFlg == 1) {
      this.model.windowTitle = "企画マーク";
    }

    // 画面初期表示のAPIリクエスト
    const vo = {
      OrderCode: this.model.orderCode,
    };
    this.getMarkCodeListService.execute(vo, (data: any) => {
      this.model.markCodeList= data.map(mark =>
        new MarkCodeInfo(
          // ゼロ埋め処理
          PlessViewUtilsSub.zeroPadding(3, mark.MarkCode),
          mark.MarkName,
        )
      )

      // 親画面から連携されたマークコードをチェックTrueに変更
      this.model.selectedMarkCodeList.map(index => {
        this.model.markCodeList.filter(i => {
          if(i.markCode == index) {
            i.check = true;
          }
        })
      })
    });
  }

  /**
   * ビュー初期化
   *
   * @memberof KYMW0002Component
   */
  public ngAfterViewInit(): void {
    // チェックボックスのあたり判定制御
    this.dtg_MarkCodeList.hostElement.addEventListener('click', e => {
      const ht = this.dtg_MarkCodeList.hitTest(e.pageX, e.pageY);
      if (ht.cellType === CellType.Cell && ht.col === 0) {
        const val = this.dtg_MarkCodeList.getCellData(ht.row, ht.col, false);
        this.dtg_MarkCodeList.setCellData(ht.row, ht.col, val ? false : true);
      }
    });
  }

  /**
   * Grid初期処理
   *
   * @param grid
  */
  onInitialized(grid: FlexGrid) {
    grid.select(-1, -1);
  }

  /**
   * ボタン押下 選択
   *
   * @memberof KYMW0001Component
   */
  public Choose(): void {
    const selectedMarkList = this.model.markCodeList.filter(mk => mk.check == true);
    const outputList = [];

    for(let i = Number(0); i < selectedMarkList.length; i++){
      const markCode = selectedMarkList[i].markCode;
      const markName = selectedMarkList[i].markName;
      outputList.push({markCode, markName});
    }

    this.model.output = outputList;
    this.closeFunction();
  }

  /**
   * パラメータ格納 呼び出し側から利用
   *
   * @param params
   * @memberof KYMW0001Component
   */
  public setParams(params: KYMW0001InputModel): void {
    this.model.windowOpenFlg = params.windowOpenFlg;
    this.model.orderCode = params.orderCode;
    this.model.selectedMarkCodeList = params.inputParam;
  }

  /**
   * パラメータ取得 呼び出し側から利用
   *
   * @param params
   * @memberof KYMW0001Component
   */
  public getParams(): KYMW0001OutputModel {
    return this.model.output;
  }
}
